import { Component, OnInit, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { UIHelper } from 'src/app/modules/acbcr/components/common/helper/ui-helper';
import { Store, select } from '@ngrx/store';
import { ApplicationState } from 'src/app/modules/acbcr/common/state/app.state';
import { getSelectedHolding } from 'src/app/modules/acbcr/common/state/reducers/holdings.reducers';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit, AfterViewInit {
  @ViewChild('sideMenu') sideMenu: ElementRef;

  isSuperAdmin = false;
  isAdmin = false;
  isOperator = false;
  isFermier = false;
  isAutoritateJudeteana = false;
  isContabil = false;
  linkExploatatie = '';

  constructor(
    private store: Store<ApplicationState>,
  ) { }

  ngOnInit() {
    this.isSuperAdmin = UIHelper.isSuperAdmin();
    this.isAdmin = UIHelper.isAdmin();
    this.isOperator = UIHelper.isOperator();
    this.isFermier = UIHelper.isFermier();
    this.isAutoritateJudeteana = UIHelper.isAutoritateJudeteana();
    this.isContabil = UIHelper.isContabil();

    if (this.isFermier) {
      this.store.pipe(select(getSelectedHolding))
      .subscribe((response: any) => {
        if (response && response.code) {
          this.linkExploatatie = '/dashboard/exploatatie/' + response.code + '/animale-exploatatie';
          localStorage.setItem('link-exploatatie', this.linkExploatatie);
        } else {
          this.linkExploatatie = localStorage.getItem('link-exploatatie');
        }
      });
    }
  }

  ngAfterViewInit() {
    if (!this.isMobile()) {
      document.body.classList.add('sidebar-enable');
    }

    this.activateMenuDropdown();
    this.addClickEvents();
  }

  isMobile() {
    return window.innerWidth < 992;
  }

  activateMenuDropdown() {
    const ulLinks = this.sideMenu.nativeElement.querySelectorAll('.side-nav-link-ref');

    for (const entry of ulLinks.values()) {
      if (window.location.hash === entry['hash']) {
        let parentUl = entry.closest('ul');
        parentUl.classList.add('show');

        break;
      }
    }
  }

  addClickEvents() {
    let elementList = this.sideMenu.nativeElement.querySelectorAll('li a');

    for (const element of elementList.values()) {
      let ulElementExists = Boolean(element.parentElement.querySelector('ul'));

      if (ulElementExists) {
        element.addEventListener('click', event => {
          let ulElement = event.currentTarget.parentElement.querySelector('ul');
          ulElement.classList.toggle('show');
        });
      } else {
        element.addEventListener('click', event => {
          if (this.isMobile()) {
            document.body.classList.remove('sidebar-enable');
          }
        });
      }
    }
  }
}
